import { FC, ReactNode } from 'react';
import { SampleSectionProviderContext } from '../../model/sampleSectionContext';
import { useSampleSectionState } from '../../model/useSampleSectionState';

type Props = {
  children: ReactNode;
};

/** Держит состояние раздела выборок над раскладками страницы: набранное переживает уход в запись */
export const SampleSectionProvider: FC<Props> = ({ children }) => {
  const state = useSampleSectionState();

  return <SampleSectionProviderContext value={state}>{children}</SampleSectionProviderContext>;
};
